import React from "react";
import HomeSplash from "../features/splash/HomeSplash";
import AboutUs from "../features/about-us/AboutUs";
import SoftwareSection from "../features/software/Software";
import FeatureCards from "../features/feature-cards/FeatureCards";
import WhatWeDo from "../features/what-we-do/WhatWeDo";
import Intro from "../features/intro/Intro";
import Pricing from "../components/Pricing";


const HomePage = () => {
    return(
        <>
            <HomeSplash/>
            <Intro/>
            <SoftwareSection />
            <WhatWeDo />
            <Pricing />
            <FeatureCards />
            <AboutUs />
        </>
    )
}

export default HomePage;